import { createAction } from "@coverme/redux";
import Axios from "axios";

export const getTest = () =>
    createAction("GET_TEST", () => Axios.get("/api/retrocheck/test").then(data => { data.data}));

export const getPatientData = (fileId,rowNumber) =>
    createAction("GET_PATIENT_DATA", async () => {
        const data = await Axios.get(`/api/retrocheck/${fileId}/${rowNumber}`);
        return {
            data: data.data,
        };
    });

export const getPatientFindings = (fileId,rowNumber) =>
    createAction("GET_PATIENT_FINDINGS", async () => {
        const data = await Axios.get(`/api/retrocheck/patientfindings/${fileId}/${rowNumber}`);
        return {
            data: data.data,
        };
    });

export const getPatientsForMrn = (mrn) =>
    createAction("GET_PATIENTS", async () => {
        const data = await Axios.get(`/api/retrocheck/patients/${mrn}`);

        return {
            data: data.data,
        };
    });

    export const getFiles = (customerId, query, cancellationToken) => {
        const config = cancellationToken != null ? { cancelToken: cancellationToken } : {};
        return createAction("GET_RETROCHECK_FILES", () =>
            Axios.post(`/api/retrocheck/files`, query || {}, config)
                .then(res => res.data)
                
        );
    };

    export const getFileInfo = (query, cancellationToken) => {
        const config = cancellationToken != null ? { cancelToken: cancellationToken } : {};
        return createAction("GET_RETROCHECK_FILE_Info", () =>
            Axios.post(`/api/retrocheck/file/fileinfo/${fileId}`)
                .then(res => res.data)
                
        );
    };

    export function updateFileFilter(filter, query) {
        return {
            type: "UPDATE_RETROCHECK_FILTER",
            filter: filter,
            query: query,
        };
    }
    
    export const getFileSummary = (fileId) =>
    createAction("GET_FILE_SUMMARY", async () => {
        const data = await Axios.get(`/api/retrocheck/filesummary/${fileId}`);
        return {
            data: data.data,
        };
    });

    export const getFileRecords = (fileId, query, cancellationToken) => {
        const config = cancellationToken != null ? { cancelToken: cancellationToken } : {};
        return createAction("GET_FILE_RECORDS", () =>
            Axios.post(`/api/retrocheck/file/records/${fileId}`, query || {}, config)
                .then(res => res.data)
        );
    };

